"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldLoadPolyfill = function () { return typeof jest !== 'undefined' || typeof window === 'undefined'; };
//# sourceMappingURL=should-laod-polyfill.js.map